import React from 'react';

import { components } from '~/assets/index';
import * as St from './styles';

interface IButtonSearch {
  onClick: () => void;
  disabled?: boolean;
}

const ButtonSearch: React.FC<IButtonSearch> = ({ onClick, disabled }) => {
  return (
    <St.Container
      $disabled={disabled}
      onClick={() => {
        if (!disabled) onClick();
      }}
    >
      <components.Search />
    </St.Container>
  );
};

export default ButtonSearch;
